import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
});

// Request interceptor: attach auth token and active company ID
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("signing_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Attach active company ID for company-scoped requests
    const activeCompanyId = localStorage.getItem("heysign_active_company_id");
    if (activeCompanyId) {
      config.headers["X-Company-ID"] = activeCompanyId;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor: handle 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem("signing_token");
        localStorage.removeItem("signing_user");
        localStorage.removeItem("heysign_active_company_id");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default api;
